<nz-space class="mobile-report-control">
  <app-apcn-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="docCode">
  </app-apcn-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-apcn-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="docCode"></app-apcn-select>
</nz-space>
